// クエリパラメータを取得するクラスをインポート
import GetQueryData from "./GetQueryData";


export default class ChangeTab {
	constructor(options) {
		// コンストラクタ引数を設定
		this.wrap = options.wrap; // ラッパー
		this.buttons = options.buttons; // トリガーボタン
		this.areas = options.areas; // タブエリア
		this.activeClass = options.activeClass || 'is-tabActive'; // アクティブクラス（デフォルトはis-tabActive）
		this.def = isNaN(parseInt(options.def, 10)) ? 0 : parseInt(options.def, 10); // デフォルトのタブ番号
		this.query = options.query; // クエリパラメータ名

		// GetQueryData インスタンスを使用して URLパラメータを取得（パラメータ例?active1=1）
		const queryData = new GetQueryData().getData();
		const tabParam = queryData[this.query]; // クエリパラメータの値を取得
		this.curSeq = this.def; // 現在のタブ番号（デフォルトは0）
        // クエリパラメータが有効な場合、その値で上書き
        if (tabParam !== null && !isNaN(parseInt(tabParam, 10)) && parseInt(tabParam, 10) < this.buttons.length) { // クエリパラメータがnullでなく、数値であり、ボタンの数より小さい場合
            this.curSeq = parseInt(tabParam, 10); // クエリパラメータの値を現在のタブ番号に設定
        }

		this.initTabs(); // タブの初期化

	}

	initTabs() {
		// イベントリスナーを各ボタンに設定
		this.buttons.forEach((btn, index) => {
			btn.addEventListener('click', () => {
				this.changeTab(index); // クリックされたボタンのインデックスを引数にしてchangeTabメソッドを実行
			});
		});

		// 初期のタブを設定
		this.changeTab(this.curSeq); // 初期のタブ番号を引数にしてchangeTabメソッドを実行
	}

	changeTab(seq) {
		// 範囲外または現在のタブと同じ場合は何もしない
		if (seq < 0 || seq >= this.buttons.length) return;

		// すべてのボタンとエリアのアクティブクラスを削除
		this.buttons.forEach(button => button.classList.remove(this.activeClass)); // ボタンにアクティブクラスを削除
		this.areas.forEach(area => area.classList.remove(this.activeClass)); // エリアにアクティブクラスを削除

		// 選択されたタブにアクティブクラスを追加
		if (this.buttons[seq]) this.buttons[seq].classList.add(this.activeClass); // クリックされたボタンにアクティブクラスを追加
		if (this.areas[seq]) this.areas[seq].classList.add(this.activeClass); // クリックされたエリアにアクティブクラスを追加

		// 現在のタブ番号を更新
		this.curSeq = seq;
	}
}